(function() {
  
  // precache images to avoid loading issues on hover
  var imageCacheDiv = document.createElement("div");
  imageCacheDiv.style.display = "none";
  document.body.appendChild(imageCacheDiv);
  
  $('.collection-thumbs').hide();
  
  $('.collection-thumb-src').each(function() {
    var thumb = document.createElement("img");
    thumb.src = $(this).data("image");
    imageCacheDiv.appendChild(thumb);
  });
  
  // swap thumbnail on hover
  $('.collection-thumb-src').mouseenter(function(e) {
    
    if ($(this).data("image") !== 'no-image') {
      
      // find container elements for all of the things we'll need
      let thumbContainer = $(this).parent().parent().parent().find('.collection-thumbs');
      let thumbList = $(this).parent().parent();
      let thumbImage = thumbContainer.find('img.collection-thumb');
      let thumbLink = thumbContainer.find('a.collection-thumb-link');      
      
      // set the image attributes and the link destination
      thumbImage.attr({src: $(this).data("image"), alt: $(this).data("image-alt")});
      thumbLink.attr({href: $(this).attr('href')});
      
      // de-activate all previously active links (for hover effects when hovering image)
      $('.menu ul.sub-menu li.collection-thumb-src-container.active').removeClass('active');
     
      
      // activate the current link
      $(this).parent().addClass('active');
      
      // set the menu min-height to match the height of the image
      thumbList.css("min-height", thumbContainer.outerHeight() - 2);
      
      // show the hover image
      thumbContainer.show();
    }
  });
  
  $('.menu ul.sub-menu').mouseleave(function(e) {
    $(this).find('.collection-thumb-src-container.active').removeClass('active');
    $(this).find('.collection-thumbs').hide();
    $(this).find('.collection-links').css("min-height", "0");
  });
})();